<template>
<!-- 交付宝 -->
<div style="display: flex;">
  <!-- 左 -->
  <div class="left-col">
    <!-- 上 -->
    <div class="main_container content-top">
      <div>
        <span style="margin-right: 20px;">可用项目额度：<b>{{ getDtac.remaincount }}</b> 个</span>
        <span style="margin-right: 20px;">关联手机号：<b>{{ getDtac.bindphone }}</b></span>
        <el-button type="text" style="color: #F56C6C;" @click="handleReplace()"><b>更换</b></el-button>
      </div>
      <div>
        <el-button type="danger" @click="handleCustomName()" v-show="getDtac.istrial==0">自定义名称</el-button>
        <el-button type="danger" @click="handleSeegmjl()" v-show="getDtac.istrial==0">购买记录</el-button>
      </div>
    </div>
    <!-- 中 -->
    <div class="main_container" style="padding: 20px;">
      <b>付费项目</b>
      <div class="project-container">
        <div class="project-card" v-for="(item, index) in paidProjects" :key="index"
        :class="{selected: currentIndex === index}" @click="selectProject(item, index)">
          <!-- <div class="project-top">{{ item.pkgname }}次卡</div> -->
          <div class="project-top">{{ item.pkgname }}</div>
          <div class="project-bottom">￥<b style="font-size: 26px;">{{ item.price }}</b></div>
        </div>
      </div>
      <div class="ffqydiv">
        <b style="margin: 10px;">付费<br>权益</b>
        <div>
          <img src="../../assets/img/ffqy1.png" style="width: 36px;"/>
          <p>无功能限制</p>
        </div>
        <div>
          <img src="../../assets/img/ffqy2.png" style="width: 36px;"/>
          <p>无限存储空间</p>
        </div>
        <div>
          <img src="../../assets/img/ffqy3.png" style="width: 36px;"/>
          <p>数据永久保留</p>
        </div>
        <div>
          <img src="../../assets/img/ffqy4.png" style="width: 36px;"/>
          <p>高效跟进进度</p>
        </div>
      </div>
      <div style="display: flex;">
        <div style="color: #FB5442;">￥<b style="font-size: 30px;margin-right: 20px;">{{ selectedProject.price }}</b></div>
        <el-button type="danger" @click="buyNow()">立即购买</el-button>
      </div>
    </div>
    <!-- 下 -->
    <div class="main_container" style="padding: 20px;">
      <b>常见问题</b>
      <ul class="numbered-list">
        <li data-number="1">
          <p style="color: #222222; font-weight: bold;">已购买的付费包可以申请退款吗？</p>
          <p style="color: #888888; text-align: left;">购买的付费包可以在48小时内申请退款，超过48小时后将无法申请退款。</p>
        </li>
        <li data-number="2">
          <p style="color: #222222; font-weight: bold;">我购买了付费包后并创建项目了，邀请成员加入，成员还需要再次付费购买吗？</p>
          <p style="color: #888888; text-align: left;">不需要，只要项目创建人购买付费后，项目成员不需要再次付费；项目成员之间可以相互发布任务。</p>
        </li>
        <li data-number="3">
          <p style="color: #222222; font-weight: bold;">交付宝的项目数据会一直保存吗？</p>
          <p style="color: #888888; text-align: left;">对于的项目数据，平台将一直保留。</p>
        </li>
      </ul>
    </div>
  </div>
  <!-- 右 -->
  <div class="main_container right-col">
    <div style="text-align: center;margin-bottom: 30px;">
      <div style="text-align: left;margin-left: 10px;"><b>甄惠装交付宝</b></div>
      <img src="../../assets/img/gongzhong.jpg" style="width: 200px;margin: 20px auto;"/>
      <div><b>使用微信扫一扫</b></div>
    </div>
    <div style="text-align: center;">
      <div style="text-align: left;margin-left: 10px;"><b>演示视频</b></div>
      <div @click="palySeevideo(videoSrc)" style="width: 200px;position: relative;cursor: pointer;margin: 20px auto;">
        <img src="../../assets/img/spfm.png" style="width: 100%;">
        <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5);">
          <img src="../../assets/img/play.png" style="width: 60px; position: absolute; top: 66px; left: 70px;"/>
        </div>
      </div>
    </div>
  </div>
  
  <!-- 播放视频 -->
  <el-dialog title="视频播放" :visible.sync="videoVisible" @close="closeVideo" width="30%" center>
    <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :playsinline="true" :options="playerOptions"/>
  </el-dialog>

  <!-- 微信扫码支付 -->
  <el-dialog title='微信扫码支付' :visible.sync="wxsmzfVisible" width="20%" center @closed="closeWxsmzf">
    <div class="wxsmzfClass"> <div><b style="font-size: 26px;">{{wxsmzfJine}} 元</b></div> <img :src="wxSmzfImg"/> </div>
  </el-dialog>
  
  <!-- 更换 -->
  <el-dialog title="更换关联手机号" :visible.sync="visibleReplace" width="25%" center>
    <div style="margin-bottom: 20px;">提示：新关联手机号必须已关注“甄惠装交付宝”小程序</div>
    <el-form>
      <el-form-item style="width:100%">
        <!-- <el-input v-model="followPhone" placeholder="请输入新的手机号" maxlength="11" @input="handlePhone"> -->
          <el-input v-model="followPhone" placeholder="请输入新的手机号" maxlength="11">
        <i slot="suffix" class="el-input__icon el-icon-success" style="color: #5cbb7a;" v-show="registered"/>
        <i slot="suffix" class="el-input__icon el-icon-error" style="color: #F56C6C;" v-show="unregistered"/>
        </el-input>
      </el-form-item>
      <el-form-item style="width:100%">
        <el-input v-model="followCode" placeholder="输入6位验证码" maxlength="6" style="width:62%"/>
        <button @click.prevent="getcode()" class="codenumber" :class="{ 'active': countdownActive }">
          {{ countdownActive ? `${countdown} 秒后重新发送` : '获取验证码' }}
        </button>
      </el-form-item>
    </el-form>
    <div style="text-align:center">
      <el-button @click="visibleReplace = false">取消</el-button>
      <el-button type="danger" @click="sureReplace()">确定</el-button>
    </div>
  </el-dialog>

  <!-- 自定义名称 -->
  <el-dialog title="自定义交付宝名称" :visible.sync="visiblecustom" width="26%" center>
    <el-form>
      <el-form-item style="width:100%"><el-input v-model="customName" placeholder="甄惠装·交付宝" maxlength="10"/></el-form-item>
    </el-form>
    <div style="line-height: 10px;padding:0 0 10px 5px;">
      <b>温馨提示：</b>
      <p>1. 可根据需求对交付宝名称自定义，最多支持10个汉字。</p>
    </div>
    <div style="text-align:center">
      <el-button @click="visiblecustom = false">取消</el-button>
      <el-button type="danger" @click="handleSure()">确定</el-button>
    </div>
  </el-dialog>

  <!-- 购买记录 -->
  <el-drawer :visible.sync="visiblegmjl">
    <template v-slot:title>
      <span style="font-size: 18px;font-weight: bolder;color: #333;">购买记录</span>
    </template>
    <p style="margin-left: 20px;">温馨提示：48小时内的购买的记录可申请退款。</p>
    <el-table :data="gmjlList" border class="table_container">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="buytime" label="购买时间" align="center"/>
      <el-table-column property="pkgname" label="付费包" align="center"/>
      <el-table-column label="操作" align="center">
        <template scope="scope">
          <span @click="handleTk(scope.row)" class="handle" v-if="scope.row.canrefund==1"> <i class="el-icon-time"/> 申请退款 </span>
          <span v-else>{{ getStatus(scope.row.status) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="prev, pager, next" @current-change="handlegmjl"
    :current-page="pageIndexgmjl" :page-size="10" :total="totalgmjl" style="float: right; margin-top: 10px"/>
  </el-drawer>
  
  <!-- 重要提示 -->
  <el-dialog title="重要提示" :visible.sync="importantNotice" width="20%" center>
    <p style="margin: 0 0 20px 0;">{{ zytxMsg }}</p>
    <div style="text-align:center;">
      <el-button @click="zyxxdelandretain(1)">删除</el-button>
      <el-button type="danger" @click="zyxxdelandretain(2)">保留</el-button>
    </div>
  </el-dialog>

  <!-- 初始化弹框 -->
  <el-dialog title="请选择企业" :visible.sync="dialogSksz" width="25%" center>
    <el-form class="findform">
      <el-form-item label="企业名称：" style="display:flex;">
        <el-select v-model="qyid" filterable placeholder="请选择企业" @change="handleChangeQymc">
          <el-option v-for="item in qyOptions" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</div>
</template>
<script>
import { toolsSendcode, getenterprise, toolsVerifycode } from "../../api/newOss";
import { configGetinfo, configBindmobile, configSetname,
  setpayee, productGetlist, purchasedGetlist, productPlaceorder, orderGetstatus, productRefund, trialCheck, trialDel } from "../../api/shopWindow";
export default {
  name: "deliveryTreasure",
  data() {
    return {
      currentIndex: 0, // 默认选中第一个项目
      selectedProject: {}, // 存储选中项目的详细信息
      paidProjects: [
        // { pkgname: '500', price: 128 },
        // { pkgname: '300', price: 88 },
        // { pkgname: '单', price: 36 },
        // { pkgname: '10', price: 68 },
      ],
      videoSrc: "https://taozhuanr-real.oss-cn-beijing.aliyuncs.com/Resource/Video/202407301023358bX94T/202407301023358bX94T.m3u8",
      videoVisible: false, // 视频播放
      playerOptions: {
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          src: "" // 视频url地址
        }],
        poster: '', // 你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      
      dialogSksz: false, // 初始化
      qyid:'', // 企业id
      qyOptions: [],

      wxsmzfVisible: false, // 微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码
      lunxun: null, // 轮询
      startTime: 0, // 初始开始请求时间
      package: {}, // 购买套餐 返回值
      orderno: '', // 订单号
      
      visibleReplace: false, // 更换
      followPhone: '', // 手机号
      registered: false, // 已注册
      unregistered: false, // 未注册
      followCode: '', // 验证码
      countdown: 60, // 倒计时初始秒数
      countdownActive: false, // 倒计时是否正在进行
      timer: null, // 用于存储定时器的引用

      visiblecustom: false, // 自定义名称
      customName: '',
      
      gmjlId: '', // 购买记录id
      visiblegmjl: false, // 购买记录抽屉
      gmjlList: [], // 购买记录列表
      pageIndexgmjl: 1,
      totalgmjl: 0,

      getDtac: {
        remaincount: 0,
        bindphone: '-',
      }, // 可用项目额度 & 关联手机号
      
      importantNotice: false, // 重要提示
      zytxMsg: '', // 文案
      
    };
  },
  methods: {
    // 获取交付宝应用配置
    initOne() {
      configGetinfo('',this.qyid).then(data => {
        if(data.resultCode == 1){
          this.getDtac = data.resultObj;
          this.customName = this.getDtac.appname;
        }else{
          this.getDtac.remaincount=0;
          this.getDtac.bindphone='-';
        }
      }).catch(err => {
        this.getDtac.remaincount=0;
        this.getDtac.bindphone='-';
      });
    },
    // 获取套餐购买记录列表
    initTwo() {
      let obj = {
        pkgtype: 1, // 套餐包类型 1=交付宝套餐
      }
      productGetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.paidProjects = data.resultObj;
          this.selectProject(this.paidProjects[0], 0);
        }else{
          this.paidProjects=[];
        }
      }).catch(err => {
        this.paidProjects=[];
      });
    },
    selectProject(item, index) {
      this.currentIndex = index;
      this.selectedProject = item;
      console.log(this.selectedProject.pkgid,'选中的套餐ID')
      console.log('选择了：'+this.selectedProject.pkgname+'次卡，价格：￥'+this.selectedProject.price)
    },
    // 播放视频
    palySeevideo(url){
      this.videoVisible = true;
      this.playerOptions.sources[0].src = url;
    },
    closeVideo() {
      this.$refs.videoPlayer.player.pause();
    },
    // 立即购买 按钮
    buyNow(){
      if(!this.qyid){
        this.$swal({
          type:'warning',
          text: '请选择企业',
          confirmButtonText: '确定', // 自定义确认按钮文本
        })
        return false;
      }
      // 检查是否有试用项目
      trialCheck('',3,this.qyid).then(data => {
        if (data.resultCode == 1) {
          // 0=没有试用项目 1=有试用项目
          if(data.resultObj == 1){
            this.importantNotice = true;
            this.zytxMsg = data.resultMsg;
          }else{
            this.zyxxbuy();
          }
        }
      });
    },
    // 删除 & 保留
    zyxxdelandretain(type){
      if(type==1){ // 删除
        let obj = {
          businesstype: 3, // 1=用户 3=企业
          businessid: this.qyid, // 业务ID（用户ID或企业ID）
        }
        trialDel(obj).then(data => {
          if (data.resultCode == 1) {
            this.zyxxbuy();
            this.importantNotice=false;
          }else{
            
          }
        });
      }else{ // 保留
        this.importantNotice=false;
        this.zyxxbuy();
      }
    },
    // 购买
    zyxxbuy(){
      let obj = {
        businesstype: 3, // 购买人类型 1=个人 2=店铺 3=企业
        businessid: this.qyid, // 购买人ID （个人=用户ID 店铺=店铺ID 企业=企业ID）
        pkgid: this.selectedProject.pkgid, // 套餐ID
      }
      productPlaceorder(obj).then(data => {
        if(data.resultCode == 1){
          this.package = data.resultObj;
          this.wxsmzfVisible = true; // 微信扫码支付
          this.importantNotice=false; // 隐藏重要提示
          // this.wxsmzfJine=this.selectedProject.price;
          this.orderno = this.package.orderno; // 订单号
          this.wxsmzfJine = this.package.price; // 支付金额 单位：元
          this.wxSmzfImg = this.package.qrcode; // 支付二维码地址
          this.startTime = new Date().getTime() // 获取触发轮询时的时间
          this.inquireData() // 调用轮询接口,开始进行轮询
        }else{
          this.$swal({
            type: 'error',
            text: data.resultMsg,
          });
        }
      }).catch(err => {
        this.$swal({
          type: 'error',
          text: data.resultMsg,
        });
      });
    },
    // 轮询请求
    inquireData() {
      const reload = () => {
        clearTimeout(this.lunxun) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.startTime > 5 * 60 * 1000) {
          clearTimeout(this.lunxun)
          return
        }
        // 3s一次, 轮询中
        this.lunxun = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      // this.orderno 订单号
      orderGetstatus('',this.orderno).then(res => {
        if (res && res.resultCode === 1) {
          // resultObj 返回一个数值类型：购买状态：0=未购买 5=已购买 10=已购买申请退款 15=退款成功
          if(res.resultObj) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.$swal({
              type: "success",
              text: "购买成功",
            });
            if(this.getDtac.istrial==1){
              this.visiblecustom=true;
            }
            // 购买成功后重新调用这个接口获取最新的数据
            this.initOne(); // 获取交付宝应用配置
            this.initTwo();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 关闭支付
    closeWxsmzf(){
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.lunxun)
    },
    // 更换
    handleReplace(){
      this.visibleReplace=true;
      this.followPhone=''; // 手机号
      this.registered=false;
      this.unregistered=false;
      this.followCode=''; // 验证码
    },
    // 输入手机号
    handlePhone(){
      if(this.followPhone.length==11){
        let obj = {
          phone: this.followPhone, // 设置 手机号
        }
        setpayee(obj,this.bbid).then(data => {
          if (data.resultCode == 1) {
            this.registered=true;
            this.unregistered=false;
          }else{
            this.registered=false;
            this.unregistered=true;
          }
        });
      }else{
        this.registered=false;
        this.unregistered=false;
      }
    },
    // 获取验证码
    getcode() {
      if (this.countdownActive) return; // 如果倒计时正在进行，不执行操作
      if (!this.followPhone) {
        this.$swal({
          type: "warning",
          text: "请先输入手机号",
        });
        return false;
      }
      // if (!this.registered) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请看提示",
      //   });
      //   return false;
      // }
      // if (!this.followCode) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请输入验证码",
      //   });
      //   return false;
      // }
      this.countdownActive = true;
      var obj = {
        type: 4,
        mobile: this.followPhone, // 手机号
      };
      toolsSendcode(obj).then(data => {
        if (data.resultCode == 1) {
          this.$message({
            message: data.resultObj,
            type: "success"
          });
          this.timer = setInterval(() => {
            if (this.countdown === 0) {
              clearInterval(this.timer); // 清除定时器
              this.countdownActive = false;
              this.countdown = 60; // 重置倒计时
            } else {
              this.countdown--;
            }
          }, 1000);
        } else {
          return false;
        }
      }).catch(error => {
        // console.error("获取data失败:", error);
        clearInterval(this.timer); // 清除定时器
        this.countdownActive = false;
        return false;
      });
    },
    // 确定更换
    sureReplace(){
      if (!this.followPhone) {
        this.$swal({
          type: "warning",
          text: "请先输入手机号",
        });
        return false;
      }
      // if (!this.registered) {
      //   this.$swal({
      //     type: "warning",
      //     text: "请看提示",
      //   });
      //   return false;
      // }
      if (!this.followCode) {
        this.$swal({
          type: "warning",
          text: "请输入验证码",
        });
        return false;
      }
      let obj = {
        type: 4,
        mobile: this.followPhone, // 手机号
        code: this.followCode, // 验证码
      };
      toolsVerifycode(obj).then(data => {
        if (data.resultCode == 1) {
          this.bindingPhone();
          // this.visibleReplace=false;
          clearInterval(this.timer); // 清除定时器
          this.countdownActive = false;
        }else{
          // this.visibleReplace=false;
          clearInterval(this.timer); // 清除定时器
          this.countdownActive = false;
        }
      });
    },
    // 绑定交付宝手机号
    bindingPhone(){
      let obj = {
        eid: this.qyid, // 企业ID
        mobile: this.followPhone, // 手机号
        operatorid: Number(localStorage.Id), // 操作人id
      }
      configBindmobile(obj,this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: '更换成功',
          })
          this.visibleReplace=false;
          this.initOne(); // 获取交付宝应用配置
        }else{
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          })
        }
      });
    },

    // 自定义名称
    handleCustomName(){
      this.visiblecustom=true;
      this.initOne(); // 获取交付宝应用配置
    },
    // 确定
    handleSure(){
      let obj = {
        eid: this.qyid, // 企业ID
        appname: this.customName, // 手机号
        operatorid: Number(localStorage.Id), // 操作人id
      }
      configSetname(obj).then(data => {
        if (data.resultCode == 1) {
          this.$swal({
            type: "success",
            text: "修改成功",
          });
          this.visiblecustom=false;
        }else{
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          })
        }
      });
    },
    // 购买记录
    handleSeegmjl() {
      this.pageIndexgmjl = 1;
      this.getgmjl();
      this.visiblegmjl = true;
    },
    // 购买记录-列表
    getgmjl(){
      let addParams = {
        pkgtype: 1, // 套餐包类型 1=交付宝套餐
        id: this.qyid, // 企业id
        pageindex: this.pageIndexgmjl, // 页码
        pagesize: 10, // 条数
      };
      purchasedGetlist(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.gmjlList = data.resultObj.list;
            this.totalgmjl = data.resultObj.totalcount;
          } else {
            this.gmjlList = [];
            this.totalgmjl = 0;
          }
        } else {
          this.gmjlList = [];
          this.totalgmjl = 0;
        }
      })
    },
    // 购买记录-分页
    handlegmjl(val) {
      this.pageIndexgmjl = val;
      this.getgmjl();
    },
    // 购买状态：0=未购买 5=已购买 10=已购买申请退款 15=退款成功
    getStatus(status) {
      switch (status) {
        case 0:
          return '未购买';
        case 5:
          return '已购买';
        case 10:
          return '已购买申请退款';
        case 15:
          return '退款成功';
        default:
          return '未知状态';
      }
    },
    // 申请退款
    handleTk(row){
      this.$swal({
        type:'warning',
        text: '您确定要操作申请退款吗？退款成功后届时将已开通的功能权益将关闭。',
        showCancelButton:true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(res=>{
        if(res.value){
          var obj = {
            orderno: row.orderno, // 订单编号
            pkgid: row.pkgid, // 套餐ID
          }
          productRefund(obj).then(data=>{
            if(data.resultCode == 1){
              this.$swal({
                type: "success",
                text:"操作成功"
              });
              this.getgmjl();
            }
          })
        }
      })
    },
    // 用户可查看的企业
    handleSksz(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      getenterprise(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              this.dialogSksz = true;
              this.qyOptions = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.dialogSksz = false;
              this.qyid = data.resultObj[0].id; // 企业id
              this.shopName = data.resultObj[0].name
              this.gonext();
            }
          }
        }
      })
    },
    gonext(){
      if(this.qyid == ""){
        this.$swal({
          type:"warning",
          text:"请选择企业名称"
        })
        return false;
      }
      this.dialogSksz = false;
      this.initOne(); // 获取交付宝应用配置
      this.initTwo();
    },
    // 获取企业名称
    handleChangeQymc(val) {
      this.qyOptions.filter(item => {
        if(item.id == val){
          this.shopName = item.name;
        }
      })
    },
    
  },
  mounted() {
    this.handleSksz(); // 用户可查看的企业
  }
}
</script>
<style scoped>
/* 左 */
.left-col {
  min-width: 60%;
  flex-grow: 1;
  margin: 0 10px;
}
/* 上 */
.content-top{
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
/* 获取验证码 */
.codenumber {
  width: 120px;
  height: 40px;
  border: solid 1px #F56C6C;
  border-radius: 4px;
  color: #F56C6C;
  cursor: pointer;
  background: none;
  float: right;
}
.codenumber.active {
  border-color: #bfbfbf;
  color: #888;
}
/* 中 */
.project-container {
  display: flex;
  /* justify-content: space-between; */
}
.project-card {
  width: 150px;
  height: 92px;
  border-radius: 8px;
  border: 1px solid #E5E5E5;
  text-align: center;
  margin: 20px 20px 0 0;
}
.project-top {
  color: #222;
  font-size: 14px;
  margin-top: 20px;
}
.project-bottom {
  color: #222;
}
.selected {
  background: #FFF7F6;
  border: 1px solid #FB5442;
}
.selected .project-top {
  color: #FB5442;
}
.selected .project-bottom {
  color: #FB5442;
}
.project-card:hover {
  cursor: pointer;
}
/* 图文 */
.ffqydiv{
  background: #F8F8F8;
  border-radius: 10px;
  display: flex;
  text-align: center;
  margin: 20px 0;
  padding: 30px;
}
.ffqydiv div{
  width: 150px;
  line-height: 0;
}

/* 下 */
.numbered-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 2em;
  line-height: 15px;
}
.numbered-list li:before {
  content: attr(data-number);
  display: inline-block;
  width: 16px;
  height: 16px;
  line-height: 16px;
  border-radius: 50%;
  background-color: #F56C6C;
  color: white;
  text-align: center;
  font-size: 12px;
  position: absolute;
  left: 0;
  top: 0;
}

/* 右 */
.right-col {
  min-width: 16%;
  padding: 20px 0;
}
</style>


// WEBPACK FOOTER //
// deliveryTreasure.vue?5ae81e6b